// src/router/routeDefs.ts
import type { RouteRecordRaw, RouteComponent } from 'vue-router'

export type RouteKey =
  | 'home'
  | 'notFound'
  | 'preview'
  | 'page'
  | 'gym'
  | 'trainer'
  | 'campaign'
  | 'post'
// | 'customerService'

export type RouteDef = {
  key: RouteKey
  component: RouteComponent
  meta?: RouteRecordRaw['meta']
  // nameBase lets you get "page-no" / "page-en" and so on.
  nameBase?: string
}

export const routeDefs: RouteDef[] = [
  { key: 'home', component: () => import('@/views/Home.vue'), nameBase: 'home', meta: { layout: 'LayoutDefault' } },
  { key: 'notFound', component: () => import('@/views/NotFound.vue'), nameBase: '404', meta: { layout: 'MinimalLayout' } },
  { key: 'preview', component: () => import('@/views/Preview.vue'), nameBase: 'preview', meta: { layout: 'LayoutDefault' } },
  { key: 'page', component: () => import('@/views/Page.vue'), nameBase: 'page', meta: { layout: 'LayoutDefault' } },
  { key: 'gym', component: () => import('@/views/Gym.vue'), nameBase: 'gym', meta: { layout: 'LayoutDefault' } },
  { key: 'trainer', component: () => import('@/views/Trainer.vue'), nameBase: 'trainer', meta: { layout: 'LayoutDefault' } },
  { key: 'campaign', component: () => import('@/views/Campaign.vue'), nameBase: 'campaign', meta: { layout: 'LayoutCampaign' } },
  { key: 'post', component: () => import('@/views/Post.vue'), nameBase: 'post', meta: { layout: 'LayoutDefault' } },
  // { key: 'customerService', component: () => import('@/views/CustomerService.vue'), nameBase: 'kundeservice', meta: { layout: 'LayoutBasic' } },
]
